import { OrganizationSearchResp, logger } from '@sheerid/jslib';

import { GetJson } from './Network';
import { getQueryParamsFromUrl } from '../utils/browser';

const country = 'country';
const name = 'name';


export async function fetchProgramOrganizations(
    orgSearchUrl: string,
    searchTerm: string,
    countryCode?: string,
): Promise<OrganizationSearchResp | undefined> {
    let url = '';

    if (orgSearchUrl) {
        if (countryCode) {
            const queryParams = getQueryParamsFromUrl(orgSearchUrl);

            queryParams.set(country, countryCode);
            queryParams.set(name, searchTerm);

            url = `${orgSearchUrl.substring(0, orgSearchUrl.indexOf('?'))}?${queryParams.toString()}`;
        } else {
            url = `${orgSearchUrl}${searchTerm}`;
        }
    }

    return fetchOrganization(url);
}

async function fetchOrganization(url: string) : Promise<OrganizationSearchResp | undefined> {
    try {
        const responseEntries = await GetJson(url) as OrganizationSearchResp;
        return responseEntries.map(entry => ({ id: entry.id, name: entry.name })) as OrganizationSearchResp;
    } catch (e) {
        logger.error(e);
        return;
    }
}
